<template>
  <div>
    <div>
      <div v-if="hasFieldErrors('dataForm.data.dateRule.active')" class="has-error">
        <span v-for="error in getFieldErrors('dataForm.data.dateRule.active')" class="help-block" :key="error">{{ error }}</span>
      </div>
      <input ref="dateRuleActiveRef"
             type="checkbox" v-model="dateRule.active" value="true"
             :data-on="pDictionary['dictionary.general.on']"
             :data-off="pDictionary['dictionary.general.off']"
             data-onstyle="success"
             name="dataForm.data.dateRule.active"/>
    </div>
    <div v-if="dateRule.active" class="bs3-margin-top">
      <date-rule-form
          v-model="dateRule"
          :p-dictionary="pDictionary"
          :p-urls="pUrls"
          :p-error-list="pErrorList"
          :p-src="pSrcId"
          :p-src-id="pSrcId"
          :p-calendar-first-day-of-week="pCalendarFirstDayOfWeek">
      </date-rule-form>
    </div>

  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refHelpers from "@/helpers/ref-helpers";
import stringHelpers from "@/helpers/string-helpers"
import DateRuleForm from "@/components/common/daterule/DateRuleForm";
import eventhelpers from "@/helpers/event-helpers";

export default {
  name: "MediaSaveFormDateRule",
  components: {DateRuleForm},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  model: {
    prop: 'pDateRule',
  },
  props: {
    pDateRule: Object,
    pCalendarFirstDayOfWeek: Number
  },
  data: function() {
    return {
      dateRule: this.pDateRule
    };
  },
  watch: {
    dateRule: function(newDateRule) {
      this.$emit('input', newDateRule);
    }
  },
  mounted: function() {
    let _component = this;
    let $dateRule = $(_component.$refs.dateRuleActiveRef);
    $dateRule.bootstrapToggle();
    $dateRule.change(function() {
      _component.dateRule.active = $dateRule.prop('checked');
    })
  },
  beforeDestroy: function() {
    let _component = this;
    let $dateRule = $(_component.$refs.dateRuleActiveRef);
    $dateRule.bootstrapToggle('destroy')
    $dateRule.off('change')
  }
}
</script>

<style scoped>

</style>